/* eslint-disable react/prop-types */
import React, { Component } from "react";
import store from "./state/store";
import Search from "./state/actions/Search";
import TruncatedSeq from "./components/TruncatedSeq";
import { truncateHgvsP1 } from "./components/TruncatedText/helpers";

export default class ResultsChooser extends Component {
  setSelectedResult = (variant, idx) => {
    // Checking if it's an already fetched result(e.g from rsid)
    // if not(e.g from vcf multiple alts), we fetch it from the server
    if (variant.hasOwnProperty("variant_id")) {
      store.dispatch({
        type: "SET_CURRENT_VARIANT",
        result: { variantResult: variant },
      });
    } else {
      Search(idx);
    }
  };

  getPNotation = (p1) => {
    if (p1 === "p.?") return p1;
    return `p.${p1}`;
  };

  getHgvs = (variant) => {
    const hgvs = `${variant.mainTranscript.gene_symbol}:${this.getPNotation(
      variant.mainTranscript.hgvs_p1
    )}`;
    const truncatedHgvs = truncateHgvsP1(hgvs);
    return ` (${truncatedHgvs})`;
  };

  getVariantFullName(variant) {
    let content;
    const { queryType } = this.props;
    if (queryType === "gene") {
      content = `Gene: ${variant.genes[0].symbol.toUpperCase()}`;
    } else if (queryType === "position") {
      if (variant.ref.length > 1) {
        content = `Range: ${variant.chromosome}:${variant.pos}..${
          parseInt(variant.pos, 10) + variant.ref.length - 1
        }`;
      } else {
        content = `Position: ${variant.chromosome}:${variant.pos}`;
      }
    } else if (queryType === "cnv") {
      content = `CNV: ${variant.chromosome}-${variant.pos}-${
        variant.end
      }-${variant.type.substr(0, 3).toUpperCase()}`;
    } else if (queryType === "transcript") {
      content = `Transcript: ${
        store.getState().variantResult.mainTranscript.name
      }`;
    } else {
      content = (
        <>
          <div>
            {`${variant.chromosome}-${variant.pos}-`}
            <TruncatedSeq seq={variant.ref} />
            -
            <TruncatedSeq seq={variant.alt} />
          </div>
          {variant.mainTranscript &&
            variant.mainTranscript.gene_symbol &&
            variant.mainTranscript.hgvs_p1 && (
              <small className="tw-ml-0.5">{this.getHgvs(variant)}</small>
            )}
        </>
      );
    }

    return <div className="tw-flex tw-items-center">{content}</div>;
  }

  render() {
    let tmpl;
    const { selectedResult, multipleResults } = this.props;
    if (
      Array.isArray(multipleResults) &&
      (multipleResults.length > 1 || Array.isArray(multipleResults[0]))
    ) {
      tmpl = multipleResults.map((variant, i) => {
        let stylingClass;
        if (Array.isArray(variant)) {
          stylingClass = `grouped-variants tw-flex ${
            i === multipleResults.length - 1 ? "last" : ""
          }`;
          return (
            <span key={i} className={stylingClass}>
              {variant.map((groupedVariant, j) => {
                return (
                  <div
                    key={`${j}-${j}`}
                    onClick={this.setSelectedResult.bind(
                      this,
                      groupedVariant,
                      i
                    )}
                    className={`tw-mr-2 tw-cursor-pointer ${
                      groupedVariant.variant_id === selectedResult.variant_id
                        ? "tw-text-white tw-font-bold tw-text-base"
                        : "hover:tw-text-white hover:tw-opacity-100 hover:tw-text-base tw-text-sm tw-opacity-70 tw-text-gray-300  no-print"
                    }`}
                  >
                    {this.getVariantFullName(groupedVariant)}
                  </div>
                );
              })}
              <div className="grouped-info">
                <i
                  className="fa fa-info-circle tw-text-gray-300 tw-opacity-70  hover:tw-text-white hover:tw-opacity-100 tw-cursor-pointer"
                  data-tooltip="These variants combined give the aminoacid variant"
                />
              </div>
            </span>
          );
        }

        stylingClass = [
          "tw-mr-2 tw-cursor-pointer",
          i === multipleResults.length - 1 ? "tw-mr-0" : "",
          variant.pos === selectedResult.pos &&
          variant.alt === selectedResult.alt
            ? "tw-text-white tw-font-bold tw-text-base"
            : "hover:tw-text-white hover:tw-opacity-100 hover:tw-text-base tw-text-sm tw-text-gray-300 tw-opacity-70 no-print",
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <div
            key={i}
            onClick={this.setSelectedResult.bind(this, variant, i)}
            className={stylingClass}
          >
            {this.getVariantFullName(variant)}
          </div>
        );
      });
    } else {
      tmpl = (
        <div className="first tw-mr-2 tw-text-white tw-font-bold tw-text-base">
          {this.getVariantFullName(selectedResult)}
        </div>
      );
    }

    return <div className="tw-flex tw-flex-wrap">{tmpl}</div>;
  }
}
